<template>
  <div class="map-balloon-content p-2">
    <div v-if="machine">
      <h2 class="card-title">{{ machine.serial_number }}</h2>
      <div><strong>{{ machine | get('model.name') }}</strong></div>
      <div>{{ machine.address }}</div>

      <div class="clearfix">
        <status-images class="my-1" :value="machine.status"></status-images>
      </div>

      <div>
        <strong>Связь: </strong>
        <span v-if="machine.is_online">
          {{ machine | get('modem.netinterface') }}
        </span>
        <span class="text-danger" v-else>нет</span>
      </div>

      <template v-if="machine.modem">
        <div>
          <strong>Состояние двери: </strong>
          <span :class="(machine.modem.door_closed ? machine.is_online : !machine.is_online) ? 'text-success' : 'text-danger'">
            {{ machine.modem.door_closed ? 'закрыта' : 'открыта' }}
          </span>
        </div>
        <div>
          <strong>Питание 220 В: </strong>
          <span :class="machine.modem.electricity ? '' : 'text-danger'">
            {{ machine.modem.electricity ? 'есть' : 'ошибка' }}
          </span>
        </div>
        <div>
          <strong>Заряд батареи: </strong>
          <span :class="machine.modem.battery < 40 ? 'text-danger' : ''">{{ machine.modem.battery }} %</span>
        </div>
      </template>

      <div>
        <strong>Монет на сдачу: </strong>
        <number :number="machine.coins_sum"/> руб.
      </div>
      <div>
        <strong>Купюр в автомате: </strong>
        <number :number="machine.banknotes_sum"/> руб.,
        <number :number="machine.banknotes_count"/> шт.
      </div>
      <!--<div><strong>Простой без продаж:</strong> <span>{{ date(machine.downtime_seconds.sales)}}</span></div>-->

      <a v-if="$root.checkPermission('web_ta_main')"
        :data-href="`/machines/${machine.id}`"
        :href="`/machines/${machine.id}`"
        class="btn btn-outline-primary btn-sm mt-2"
      >Перейти к карточке автомата &raquo;</a>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    data: () => ({}),
    props: {
      machine: {},
    },
    watch: {},
    methods: {
      date (value) {
        if (value !== null) {
          return moment.duration(value, 'seconds').humanize()
        } else {
          return 'Неизвестно'
        }
      },

    },
  }
</script>

<style lang="scss">
  @import "boot";
  .map-balloon-content {
    font-size: $font-size-sm;
    font-family: $font-family-base;
    line-height: $line-height-base;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/balloon.vue